define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ContactInfo = (function () {
        function ContactInfo() {
            this.Tel = null;
            this.Fax = null;
            this.Email = null;
        }
        return ContactInfo;
    }());
    exports.ContactInfo = ContactInfo;
});
//# sourceMappingURL=ContactInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/ContactInfo.js
// module id = 148
// module chunks = 0